var map = {
	"./DataProduct": 46,
	"./DataProduct.js": 46,
	"./Images/BBQ_salad.png": 235,
	"./Images/apricot_compote.png": 236,
	"./Images/blackberry_compote.png": 237,
	"./Images/blackberry_jam.png": 238,
	"./Images/cherries_jam.png": 239,
	"./Images/cherry_compote.png": 240,
	"./Images/cherry_jam.png": 241,
	"./Images/cherry_plum_compote.png": 242,
	"./Images/composto.png": 243,
	"./Images/dogwood_compote.png": 244,
	"./Images/dogwood_jam.png": 245,
	"./Images/feijoa_compote.png": 246,
	"./Images/feijoa_hawthorn_compote.png": 247,
	"./Images/fig_jam.png": 248,
	"./Images/fried_eggplant.png": 249,
	"./Images/gherkins_350_gr.png": 250,
	"./Images/jam.png": 251,
	"./Images/lecho.png": 252,
	"./Images/narsharab.png": 253,
	"./Images/nut_jam.png": 254,
	"./Images/pasta.png": 255,
	"./Images/pasta_280_gr.png": 256,
	"./Images/pasta_70_gr.jpg": 257,
	"./Images/pasta_70_gr.png": 258,
	"./Images/pasta_770_gr.png": 259,
	"./Images/pasta_amphora.png": 260,
	"./Images/peach_compote.png": 261,
	"./Images/peeled_tomatoes.png": 262,
	"./Images/peeled_tomatoes_glass.png": 263,
	"./Images/peeled_tomatoes_juice.png": 264,
	"./Images/pickle.png": 265,
	"./Images/pickle_3_kg.png": 266,
	"./Images/pickle_680_gr.png": 267,
	"./Images/pickle_mar_680_gr.png": 268,
	"./Images/pickle_mar_squares.png": 269,
	"./Images/pickle_squares.png": 270,
	"./Images/pickled_assorted.png": 271,
	"./Images/pickled_cherry_tomatoes.png": 272,
	"./Images/pickled_tomatoes.png": 273,
	"./Images/pickled_tomatoes_680_gr.png": 274,
	"./Images/plum_compote.png": 275,
	"./Images/pomegranate.png": 276,
	"./Images/quince_compote.png": 277,
	"./Images/quince_jam.png": 278,
	"./Images/raspberry_jam.png": 279,
	"./Images/rose_jam.png": 280,
	"./Images/sliced_pickled_cucumbers.png": 281,
	"./Images/sliced_salted_cucumbers.png": 282,
	"./Images/sliced_tomatoes.png": 283,
	"./Images/souse.png": 284,
	"./Images/souse_hot.png": 285,
	"./Images/souse_hot_spices.png": 286,
	"./Images/souse_spices.png": 287,
	"./Images/squash_530_gr.jpg": 288,
	"./Images/squash_530_gr.png": 289,
	"./Images/strawberry_compote.png": 290,
	"./Images/strawberry_jam.png": 291,
	"./Images/thorn_compote.png": 292,
	"./Images/unpeeled_tomatoes.png": 293,
	"./Images/white_cherry_jam.png": 294
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 64;